import React, { ReactNode } from 'react';

import styles from './styles.module.scss';

interface InfoBoxProps {
  header: string;
  description: string;
  image: ReactNode;
  testId?: string;
}

const InfoBox = ({ header, description, image, testId }: InfoBoxProps) => {
  return (
    <div className={styles.infoBox} data-testid={testId}>
      <div className={styles.imageSection}>{image}</div>
      <div className={styles.textSection}>
        <div
          className={styles.header}
          data-testid={testId ? `${testId}-header` : undefined}
        >
          {header}
        </div>
        <div
          className={styles.description}
          data-testid={testId ? `${testId}-description` : undefined}
        >
          {description}
        </div>
      </div>
    </div>
  );
};

export default InfoBox;
